import { GeneralUtilities } from "./general";

export class PurchaseOrderQuestion {
  public static question_invoice_main = [
    {
      type: "radio",
      question: "¿La información es legible?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "Carga un documento que sea legible: en tamaño carta y con buena nitidez",
          },
        },
      ],
      answer: undefined,
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Carga un documento que esté escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      answer: undefined,
      page: 1,
    },
    {
      type: "select",
      question: "¿Cuál de estas leyendas tiene la factura?",
      control: "text_invoice",
      options: [
        { label: "ISAN", value: { value: "ISAN", incident: false } },
        { label: "NOM 160", value: { value: "NOM 160", incident: false } },
        { label: "Demo", value: { value: "Demo", incident: false } },
        { label: "Asignación al activo fijo", value: { value: "Asignación al activo fijo", incident: false } },
        { label: "Carta resguardo", value: { value: "Carta resguardo", incident: false } },
        {
          label: "Condiciones del auto",
          value: {
            value: "Condiciones del auto",
            incident: true,
            incident_text:
              "Carga un documento donde aparezca alguna de estas leyendas: Nuevo, ISAN, NOM 160, Demo, Asignación al activo fijo, Carta resguardo.",
          },
        },
        {
          label: "NOM 122",
          value: {
            value: "NOM 122",
            incident: true,
            incident_text:
              "Carga un documento donde aparezca alguna de estas leyendas: Nuevo, ISAN, NOM 160, Demo, Asignación al activo fijo, Carta resguardo.",
          },
        },
        {
          label: "Copia sin valor",
          value: {
            value: "Copia sin valor",
            incident: true,
            incident_text:
              "Carga un documento donde aparezca alguna de estas leyendas: Nuevo, ISAN, NOM 160, Demo, Asignación al activo fijo, Carta resguardo.",
          },
        },
      ],
      answer: undefined,
      page: 2,
    },
    {
      type: "radio",
      question: "¿La factura tiene la leyenda Copia sin valor?",
      control: "copy_invoice",
      options: [
        {
          label: "Sí",
          value: {
            value: "si",
            incident: true,
            incident_text: 'Incidencia: Carga un documento donde no aparezca la layenda "Copia sin valor".',
          },
        },
        { label: "No", value: { value: "no", incident: false } },
      ],
      answer: undefined,
      page: 2,
    },
    {
      type: "textbox",
      question: "Folio fiscal capturado",
      control: "fiscal_code",
      answer: undefined,
      page: 3,
    },
    {
      type: "radio",
      question: "¿Se pudo consultar la información en el portal del SAT?",
      control: "info_sat",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "No se detectó informacion ni se pudo leer el código QR, carga un archivo con buena nitidez.",
          },
        },
      ],
      answer: undefined,
      page: 3,
    },
    {
      type: "select",
      question: "¿Qué elemento usaste para hacer la consulta en el portal?",
      control: "consult_portal",
      options: [
        { label: "Código QR", value: { value: "Código QR", incident: false } },
        { label: "Folio Fiscal", value: { value: "Folio Fiscal", incident: false } },
      ],
      answer: undefined,
      page: 3,
    },
    {
      type: "radio",
      question: "¿La factura está vigente ante el SAT?",
      control: "current_invoice",
      options: [
        { label: "Sí", value: { value: "Código QR", incident: false } },
        {
          label: "No",
          value: {
            value: "Folio Fiscal",
            incident: true,
            incident_text:
              "Carga un documento que esté vigente ante el SAT, revisa con la agencia si existe otra factura y si en su momento fue reemplazada correctamente. ",
          },
        },
      ],
      answer: undefined,
      page: 4,
    },
    {
      type: "radio",
      question: "¿Los datos del portal del SAT corresponden con los de la factura impresa?",
      control: "corresponding_data",
      options: [
        { label: "Sí", value: { value: "Código QR", incident: false } },
        {
          label: "No",
          value: {
            value: "Folio Fiscal",
            incident: true,
            incident_text:
              "Carga un documento donde los datos impresos en la factura coincidan con lo que muestra el SAT.",
          },
        },
      ],
      answer: undefined,
      page: 4,
    },
    {
      type: "textbox",
      question: "Nombre del Emisor",
      control: "issuer_name",
      answer: undefined,
      label: "Nombre del Emisor",
      page: 5,
    },
    {
      type: "textbox",
      question: "Nombre del Receptor",
      control: "receiver_name",
      answer: undefined,
      label: "Nombre del Receptor",
      page: 5,
    },
    {
      type: "textbox",
      question: "Monto de la factura",
      control: "invoice_amount",
      answer: undefined,
      label: "Monto de la factura",
      page: 5,
    },
    {
      type: "textbox",
      question: "Número de identificación vehicular (NIV)",
      control: "niv",
      answer: undefined,
      label: "NIV",
      page: 6,
    },
    {
      type: "textbox",
      question: "Modelo (Año)",
      control: "model",
      answer: undefined,
      label: "Modelo",
      page: 6,
    },
    {
      type: "textbox",
      question: "Clave vehicular",
      control: "key_vehicle",
      answer: undefined,
      label: "Clave vehicular",
      page: 6,
    },
    {
      type: "textbox",
      question: "Número de motor",
      control: "engine_number",
      answer: undefined,
      label: "Número de motor",
      page: 6,
    },
  ];

  public static question_invoice_no_main = [
    {
      type: "radio",
      question: "¿La información es legible?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "Carga un documento que sea legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      answer: undefined,
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Carga un documento que esté escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      answer: undefined,
      page: 1,
    },
    /* {
      type: "checkbox",
      question: "Datos en la factura de Origen",
      control: "invoice_info_main",
      label: "Número de identificación vehicular",
      answer: undefined,
      page: 2
    },*/
    {
      type: "radio",
      question: "¿Los datos que seleccionaste coinciden con los de la factura de origen?",
      control: "match_data_invoice",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: { value: "no", incident: true, incident_text: "¿En este caso cuál sería la incidencia?" },
        },
      ],
      answer: undefined,
      page: 2,
    },
    {
      type: "radio",
      question: "¿Se pudo consultar la información en el SAT con el codigo QR?",
      control: "info_sat",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "No se detectó informacion ni se pudo leer el código QR, carga un archivo con buena nitidez.",
          },
        },
      ],
      answer: undefined,
      page: 3,
    },
    {
      type: "radio",
      question: "¿La factura está vigente ante el SAT?",
      control: "invoice_valid",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Carga un documento que esté vigente ante el SAT, revisa con la agencia si existe otra factura y si en su momento fue reemplazada correctamente. ",
          },
        },
      ],
      answer: undefined,
      page: 3,
    },
    {
      type: "radio",
      question: "¿Todos los datos del portal SAT corresponden con los de la factura impresa",
      control: "invoice_correspond",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Carga un documento donde los datos impresos en la factura coincidan con lo que muestra el SAT.",
          },
        },
      ],
      answer: undefined,
      page: 3,
    },
    /*{
      type: "radio",
      question: "¿Se pudo consultar la información en el SAT con el código QR?",
      control: "invoice_qr",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Carga un documento donde los datos impresos en la factura coincidan con lo que muestra el SAT.",
          },
        },
      ],
      answer: undefined,
      page: 4,
    },
    {
      type: "radio",
      question: "¿La factura está vigente ante el SAT?",
      control: "invoice_current",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Carga un documento donde los datos impresos en la factura coincidan con lo que muestra el SAT.",
          },
        },
      ],
      answer: undefined,
      page: 4,
    },
    {
      type: "radio",
      question: "¿Todos los datos del portal del SAT corresponden con los de la factura impresa?",
      control: "invoice_qr",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Carga un documento donde los datos impresos en la factura coincidan con lo que muestra el SAT.",
          },
        },
      ],
      answer: undefined,
      page: 4,
    },*/
    {
      type: "textbox",
      question: "Nombre del Emisor",
      control: "issuer_name",
      answer: undefined,
      label: "Nombre del Emisor",
      page: 4,
    },
    {
      type: "textbox",
      question: "Nombre del Receptor",
      control: "receiver_name",
      answer: undefined,
      label: "Nombre del Receptor",
      page: 4,
    },
    {
      type: "textbox",
      question: "Monto de la factura",
      control: "invoice_amount",
      answer: undefined,
      label: "Monto de la factura",
      page: 4,
    },
  ];

  public static question_invoice_endorsement = [
    {
      type: "radio",
      question: "¿La información es legible?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "Carga un documento que sea legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      answer: undefined,
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Carga un documento que esté escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      answer: undefined,
      page: 1,
    },
    {
      type: "radio",
      question: "¿La firma y/o rubrica coincide con el anterior dueño (quien cede derechos)?",
      control: "last_owner_signature",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        { label: "No", value: { value: "no", incident: true, incident_text: "NOS FALTA LA INCIDENCIA TEXTUAL" } },
      ],
      answer: undefined,
      page: 1,
    },
    {
      type: "textbox",
      question: "Nombre del Receptor",
      control: "receiver_name",
      answer: undefined,
      page: 2,
    },
  ];
}
